import "es6-shim";
import * as React from 'react';
import { Routes } from "../../constants/routes";
import "../../styles/Main.css";
import AcquireHealthCardNumber from "../AcquireHealthCardNumber/AcquireHealthCardNumber.container";
import AdminSetupPage from "../AdminSetupPage/AdminSetupPage.container";
import AppointmentConfirmation from '../AppointmentConfirmation/AppointmentConfirmation.container';
import ClinicLoginPage from "../ClinicLoginPage/ClinicLoginPage.container";
import { ErrorPopup } from '../ErrorPopup';
import Introduction from "../Introduction/Introduction.container";
import { KeyboardKiosk } from "../KeyboardKiosk/KeyboardKiosk";
import LanguageSelection from "../LanguageSelection/LanguageSelection.container";
import PatientOverview from "../PatientOverview/PatientOverview.container";
import SnackBarPopup from "../SnackBarPopup/SnackBarPopup.container";
import SatisfactorySurveryContainer from "../SatisfactorySurvery/SatisfactorySurvery.container";
import { getErrorMessages, getRedirectPatientMessage } from "../../services/Language/GetErrorMessages";
import { DebugWindow } from "../DebugWindow/DebugWindow";
import { IMainProps } from "./Main.container";
import { ButtonTimer } from "../DebugWindow/ButtonTimer";

export const Main = (props: IMainProps) => {
    const [showDebug, setShowDebug] = React.useState<boolean>(false);

    const renderErrorPopup = () => {
        if (props.error.showErrorPopup) {
            // Force the application to return to the main screen and clean the store after 10 seconds if the user doesn't click the ok button.
            let autoRedirectTimer;
            if (props.error.returnToMainScreen) {
                autoRedirectTimer = setTimeout(() => {
                    props.cleanAndReturn()
                }, 10000);
            }
            return (
                <ErrorPopup
                    onClose={() => {
                        clearTimeout(autoRedirectTimer);
                        if (props.error.returnToMainScreen) {
                            // Close popup, clean the store and return the user to the home screen
                            props.cleanAndReturn();
                        } else {
                            // Close popup only
                            props.closeErrorPopup();
                        }
                    }}
                    text={{
                        title: props.localeString.titles.ErrorTitle,
                        closeButton: props.localeString.labels.CloseButton,
                        errorMessage: getErrorMessages(props.localeString.messagesInstructions, props.error.currentErrorCode)
                    }}
                    show={props.error.showErrorPopup}
                >
                    <h2 style={{ color: "#000099" }}>
                        {getRedirectPatientMessage(props.localeString.messagesInstructions, props.error.currentErrorCode)}
                    </h2>
                </ErrorPopup>
            );
        } else {
            return null
        }
    }
    if (!props.isUserAuthenticated) {
        return (
            <div style={{ height: "100%" }}>
                {props.enableDebugWindowFeature && <ButtonTimer onClick={() => setShowDebug(true)} />}
                <div className="main-container" >
                    <div className={"route-container ".appendIf(props.showKeyboard, "keyboard-active")}>
                        <ClinicLoginPage />
                        {
                            props.showKeyboard &&
                            <KeyboardKiosk
                                onChange={(value) => props.onKeyboardChangeValue(value)}
                                value={props.currentInputValue}
                                show={props.showKeyboard}
                                hide={() => props.hideKeyboard()}
                                enter={() => props.enterFunction()}
                                keyboardType={props.keyboardType}
                            />
                        }
                    </div>
                </div>
                {showDebug && props.enableDebugWindowFeature && (
                    <DebugWindow
                        onClose={() => setShowDebug(false)}
                        messages={props.debugMessages}
                        onClearMessages={() => props.onClearDebugMessages()}
                    />
                )}
            </div>
        );
    }

    const renderMain = () => {
        switch (props.currentRoute) {
            case Routes.adminSetup: return <AdminSetupPage />;
            case Routes.languageSelection: return <LanguageSelection />
            case Routes.acquireHealthCardNumber: return <AcquireHealthCardNumber />
            case Routes.appointmentConfirmation: return <AppointmentConfirmation />
            case Routes.patientOverview: return <PatientOverview />
            case Routes.introduction: return <Introduction />
            case Routes.satisfactorySurvey: return <SatisfactorySurveryContainer />
            default:
                return (
                    <div className="text-center" style={{ width: "100%" }}>
                        <button
                            className="btn btn-lg btn-primary"
                            onClick={() => window.location.reload()}
                        >
                            <i className="fa fa-refresh" aria-hidden="true" />
                        </button>
                    </div>
                );
        }
    }

    return (
        <div style={{ height: "100%" }}>
            {props.enableDebugWindowFeature && <ButtonTimer onClick={() => setShowDebug(true)} />}
            <div className="main-container" >
                {
                    props.showLanguageSelection &&
                    <LanguageSelection />
                }
                <div className="route-container">
                    {
                        renderMain()
                    }
                </div>
                {
                    renderErrorPopup()
                }
            </div>
            {
                props.showKeyboard &&
                <KeyboardKiosk
                    onChange={(value) => props.onKeyboardChangeValue(value)}
                    value={props.currentInputValue}
                    show={props.showKeyboard}
                    hide={() => { props.hideKeyboard() }}
                    enter={() => { props.enterFunction() }}
                    keyboardType={props.keyboardType}
                />
            }
            <SnackBarPopup />
            {showDebug && props.enableDebugWindowFeature && (
                <DebugWindow
                    onClose={() => setShowDebug(false)}
                    messages={props.debugMessages}
                    onClearMessages={() => props.onClearDebugMessages()}
                />
            )}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/Main/Main.component.tsx